import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll, showCreateListingsLink, customLink } =
    props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;

  const createListingLinkMaybe = showCreateListingsLink ? (
    <NamedLink className={css.createListingLink} name="NewListingPage">
      <FormattedMessage id="SearchPage.createListing" />
    </NamedLink>
  ) : null;

  const customLinkMaybe = customLink ? (
    <a
      href={customLink.url}
      target="_blank"
      rel="noopener noreferrer"
      className={css.customLink}
    >
      {customLink.text}
    </a>
  ) : null;

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <p>
        <FormattedMessage id="SearchPage.noResults" />
      </p>
      {hasSearchParams ? (
        <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
          <FormattedMessage id="SearchPage.resetAllFilters" />
        </button>
      ) : null}
      <p>{createListingLinkMaybe}</p>
      {customLinkMaybe ? <p>{customLinkMaybe}</p> : null}
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
